import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=2f219c7c&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=ts&"
export * from "./Header.vue?vue&type=script&lang=ts&"
import style0 from "./Header.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./Header.vue?vue&type=style&index=1&id=2f219c7c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f219c7c",
  null
  
)

component.options.__file = "Header.vue"
export default component.exports